import { memo } from 'react'

import { SupportButton } from '@/features/SupportButton/ui/SupportButton.tsx'
import { AccountButton } from '@/features/account'
import { LoginButton, RegisterButton } from '@/features/auth'
import { LikesButton } from '@/features/likes'
import { NotificationsButton } from '@/features/notifications'
import { ShareButton } from '@/features/share'

import { MobileMenu } from './MobileMenu'

interface HeaderMenuProps {
	isAuthorized: boolean
}

// We need memo here because AppHeader rerenders quite often
export const HeaderMenu = memo(({ isAuthorized }: HeaderMenuProps) => {
	return (
		<ul className="flex gap-4">
			<li className="max-xl:hidden">
				<SupportButton size="sm" />
			</li>
			<li className="max-xl:hidden">
				<ShareButton />
			</li>
			<li className="max-xl:hidden">
				<NotificationsButton />
			</li>
			<li>
				<LikesButton />
			</li>
			<li className="max-xl:hidden">
				<AccountButton />
			</li>
			<li className="max-xl:hidden">
				{!isAuthorized && (
					<div className="flex gap-4">
						<RegisterButton
							className="w-28"
							variant="outline"
							size="sm"
						/>
						<LoginButton
							className="w-28"
							variant="outline"
							size="sm"
						/>
					</div>
				)}
			</li>

			<li className="xl:hidden">
				<MobileMenu isAuthorized={isAuthorized} />
			</li>
		</ul>
	)
})

HeaderMenu.displayName = 'HeaderMenu'
